import React, { useContext } from 'react';

import ImageComponent from '@components/common/ImageComponent/ImageComponent';
import { AUTH_TYPE } from '@constants/homepage';
import ivclass from '@invideoio/web-shared/Modules/IVClass';
import { RedirectContext } from '@store/store';
import { sendAmplitudeAnalyticEvent, AmplitudeEvents } from '@utils/analytics';
import { isUserLoggedIn } from '@utils/common.utils';

function AffiliteInfo({ infoSection }: any) {
  const { handleClick } = useContext(RedirectContext);

  const handleCtaClick = () => {
    if (!isUserLoggedIn()) {
      sendAmplitudeAnalyticEvent(AmplitudeEvents.clickSignUp, {
        btnPosition: 'Affiliate Offer',
      });
    }

    handleClick('', { tab: AUTH_TYPE.SIGNUP });
  };

  return (
    <div
      className={ivclass(
        'iv-flex md:iv-flex-col sm:iv-flex-col iv-justify-center iv-container iv-px-40 sm:iv-px-20 iv-max-w-6xl',
        'iv-py-150 md:iv-py-100 sm:iv-py-50 iv-mx-auto',
      )}
    >
      <div
        className={ivclass(
          'iv-flex-1 sm:iv-mb-30 sm:iv-mx-auto iv-mr-40 sm:iv-mr-auto',
        )}
      >
        {infoSection.video?.src ? (
          <video
            loop
            muted
            playsInline
            autoPlay
            className="iv-w-full iv-max-w-sm"
          >
            <source type="video/mp4" src={infoSection.video.src} />
          </video>
        ) : (
          <ImageComponent
            elementype="native"
            className={ivclass(
              'iv-w-[350px] sm:iv-w-[250px]',
              'iv-object-cover',
              infoSection.circularImg &&
                'iv-rounded-full iv-h-[350px] sm:iv-h-[250px]',
            )}
            src={infoSection.imgCircle.webp}
            alt={infoSection.imgCircle.alt}
          />
        )}
      </div>
      <div
        className={ivclass(
          'iv-flex-[2] iv-flex iv-flex-col sm:iv-items-center',
          'iv-font-medium',
        )}
      >
        <div
          className={ivclass(
            'iv-text-heading-xs md:iv-text-heading-2xs sm:iv-text-heading-3xs',
            ' iv-pb-10',
          )}
        >
          {infoSection.content.title}
        </div>
        <div
          className={ivclass(
            'iv-text-heading-4xs md:iv-text-heading-5xs sm:iv-text-body-xl',
            ' iv-pb-10',
          )}
        >
          {infoSection.content.p1}
        </div>
        <div className={ivclass('iv-pb-10')}>{infoSection.content.p2}</div>
        <div className={ivclass('iv-pb-10')}>{infoSection.content.p3}</div>
        <div
          className={ivclass(
            'iv-text-body-3xl iv-font-bold iv-pb-10 sm:iv-text-center',
          )}
        >
          {infoSection.content.bold}
        </div>
        <div className="iv-mt-20">
          <button
            className={ivclass(
              'iv-bg-blue iv-text-grey-0 iv-py-10 iv-px-20 iv-rounded-lg',
              '',
            )}
            type="button"
            onClick={handleCtaClick}
          >
            Get Started
          </button>
        </div>
      </div>
    </div>
  );
}

export default AffiliteInfo;
